import { trigger, animate, style, group, transition, stagger, query, animateChild } from '@angular/animations';

export const slideInAnimation =
    trigger('routeAnimations', [
        transition('* <=> *', [
            query(':enter, :leave', [
                style({
                    position: '{{position}}',
                    bottom: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    overflow: 'hidden'
                })
            ], { optional: true }),
            query(':enter', [
                style({
                    opacity: 0,
                    'transform': 'translateY({{transform}}px)'
                })
            ], { optional: true }),
            query(':leave', [
                style({
                    opacity: 1,
                    'transform': 'translateY(0)'
                }),
                animate('0.4s cubic-bezier(0.3, 0.3, 0.3, 1)', style({
                    opacity: 0,
                    'transform': 'translateY(-{{transform}}px)'
                }))
            ], { optional: true }),
            query(':enter', [
                style({
                    opacity: 0,
                    'transform': 'translateY(-{{transform}}px)'
                }),
                animate('0.4s cubic-bezier(0.3, 0.3, 0.3, 1)', style({
                    opacity: 1,
                    'transform': 'translateY(0)'
                }))
            ], { optional: true })
        ], { params: { transform: 0, position: 'absolute' } }),
    ]);

export const fadeAnimation =
    trigger('fadeAnimation', [
        transition('* => *', [
            query(':enter', [
                style({
                    opacity: 0,
                    'transform': 'translateY(100px)'
                })
            ], { optional: true }),
            query(':leave', [
                style({
                    opacity: 1,
                    'transform': 'translateY(0)'
                }),
                stagger('20ms',
                    animate('0.4s cubic-bezier(0.3, 0.3, 0.3, 1)', style({
                        opacity: 0,
                        'transform': 'translateY(-100px)'
                    }))
                )
            ], { optional: true }),

            query(':enter', [
                style({
                    opacity: 0,
                    'transform': 'translateY(100px)'
                }),
                stagger('20ms',
                    animate('0.4s cubic-bezier(0.3, 0.3, 0.3, 1)', style({
                        opacity: 1,
                        'transform': 'translateY(0)'
                    }))
                )
            ], { optional: true })
        ])
    ]);

export const fadeAnimationResponsive =
    trigger('fadeAnimationResponsive', [
        transition('* => *', [
            query(':enter',
                [
                    style({
                        opacity: 0,
                        'transform': 'translateY(100px)'
                    })
                ],
                { optional: true }
            ),

            query(':leave',
                [
                    style({
                        opacity: 1,
                        'transform': 'translateY(0)'
                    }),
                    stagger('10ms',
                        animate('0.2s cubic-bezier(0.3, 0.3, 0.3, 1)', style({
                            opacity: 0,
                            'transform': 'translateY(-100px)'
                        })))
                ],
                { optional: true }
            ),

            query(':enter',
                [
                    style({
                        opacity: 0,
                        'transform': 'translateY(100px)'
                    }),
                    stagger('10ms',
                        animate('0.2s cubic-bezier(0.3, 0.3, 0.3, 1)', style({
                            opacity: 1,
                            'transform': 'translateY(0)'
                        })))
                ],
                { optional: true }
            )
        ])
    ]);

export const fadeHeaderAnimation =
    trigger('fadeHeaderAnimation', [
        transition('* => *', [
            query(':enter',
                [
                    style({
                        opacity: 0,
                        'transform': 'translateY(-100px)'
                    })
                ],
                { optional: true }
            ),

            query(':leave',
                [
                    style({
                        opacity: 1,
                        'transform': 'translateY(0)'
                    }),
                    stagger('20ms',
                        animate('0.4s cubic-bezier(0.3, 0.3, 0.3, 1)', style({
                            opacity: 0,
                            'transform': 'translateY(-100px)'
                        })))
                ],
                { optional: true }
            ),

            query(':enter',
                [
                    style({
                        opacity: 0,
                        'transform': 'translateY(-100px)'
                    }),
                    stagger('20ms',
                        animate('0.4s cubic-bezier(0.3, 0.3, 0.3, 1)', style({
                            opacity: 1,
                            'transform': 'translateY(0)'
                        }))
                    )
                ],
                { optional: true }
            )
        ])
    ]);

export const socialFade =
    trigger('fadeIn', [
        transition('* => *', [
            query(':enter',
                [
                    style({
                        opacity: 0,
                        'transform': 'translateY(100px)'
                    })
                ],
                { optional: true }
            ),

            query(':leave',
                [
                    style({
                        opacity: 1,
                        'transform': 'translateY(0)'
                    }),
                    stagger('20ms',
                        animate('0.4s cubic-bezier(0.3, 0.3, 0.3, 1)', style({
                            opacity: 0,
                            'transform': 'translateY(-100px)'
                        })))
                ],
                { optional: true }
            ),

            query(':enter',
                [
                    style({
                        opacity: 0,
                        'transform': 'translateY(100px)'
                    }),
                    stagger('20ms',
                        animate('0.4s 0.3s cubic-bezier(0.3, 0.3, 0.3, 1)', style({
                            opacity: 1,
                            'transform': 'translateY(0)'
                        })))
                ],
                { optional: true }
            )
        ])
    ]);

export const transformFade =
    trigger('fadeIn', [
        transition('* => *', [
            query(':enter',
                [
                    style({
                        opacity: 0,
                        'transform': 'translateY(100px)'
                    })
                ],
                { optional: true }
            ),

            query(':leave',
                [
                    style({
                        opacity: 1,
                        'transform': 'translateY(0)'
                    }),
                    stagger('20ms',
                        animate('0.4s cubic-bezier(0.3, 0.3, 0.3, 1)', style({
                            opacity: 0,
                            'transform': 'translateY(-100px)'
                        })))
                ],
                { optional: true }
            ),

            query(':enter',
                [
                    style({
                        opacity: 0,
                        'transform': 'translateY(100px)'
                    }),
                    stagger('20ms',
                        animate('0.4s 0.3s cubic-bezier(0.3, 0.3, 0.3, 1)', style({
                            opacity: 1,
                            'transform': 'translateY(0)'
                        })))
                ],
                { optional: true }
            )
        ])
    ]);

export const workAnimation = [
    trigger('parentAnimation', [
        transition('closed => opened', [
            group([
                query('.post-page-wrapper.post-active .post-active-wrapper', [
                    style({
                        width: '{{width}}px',
                        height: '{{height}}px',
                        left: '{{left}}px',
                        top: '{{top}}px',
                        bottom: '{{bottom}}px',
                        right: '{{right}}px',
                        zIndex: 99,
                        position: 'fixed',
                    }),
                    animate('400ms cubic-bezier(.25,.15,.35,1)',
                        style({
                            width: '{{fullwidth}}px',
                            height: '{{fullheight}}px',
                            left: '-10px',
                            top: '{{screentop}}px',
                            zIndex: 999,
                            position: 'fixed',
                            bottom: '-10px',
                            right: '-10px',
                        }))
                ], { optional: true }),
                query('.post-page-wrapper.post-active h3', [
                    style({
                        opacity: 1
                    }),
                    animate('400ms cubic-bezier(.25,.15,.35,1)',
                        style({
                            opacity: 0
                        }))
                ], { optional: true }),
                query('.post-page-wrapper.post-active h5', [
                    style({
                        opacity: 1
                    }),
                    animate('400ms cubic-bezier(.25,.15,.35,1)',
                        style({
                            opacity: 0
                        }))
                ], { optional: true }),
                query('.post-page-wrapper.post-active .post-content-wrapper', [
                    style({
                        left: '45px',
                        top: '{{wrapperTop}}px'
                    }),
                    animate('400ms cubic-bezier(.25,.15,.35,1)',
                        style({
                            left: '80px',
                            top: '{{wrapperTopFull}}px'
                        }))
                ], { optional: true }),
            ])
        ]),
        transition('opened => closed', [
            group([
                query('.post-page-wrapper.post-active .post-active-wrapper', [
                    style({
                        width: '{{fullwidth}}px',
                        height: '{{fullheight}}px',
                        top: '{{screentop}}px',
                        zIndex: 999,
                        left: '-10px',
                        right: '-10px',
                        bottom: '-10px',
                        position: 'fixed'
                    }),
                    animate('400ms 500ms cubic-bezier(.25,.15,.35,1)',
                        style({
                            width: '{{widthback}}px',
                            height: '{{heightback}}px',
                            left: '{{leftback}}px',
                            top: '{{topback}}px',
                            bottom: '{{bottomback}}px',
                            right: '{{rightback}}px',
                            position: 'fixed',
                            zIndex: 99
                        }))
                ], { optional: true }),
                query('.post-page-wrapper.post-active .post-content-wrapper', [
                    style({
                        left: '80px',
                        top: '{{wrapperTopFull}}px'
                    }),
                    animate('400ms 500ms cubic-bezier(.25,.15,.35,1)',
                        style({
                            left: '45px',
                            top: '{{wrapperTopBack}}px'
                        }))
                ], { optional: true }),
            ])
        ])
    ]),
    trigger('childAnimation', [
        transition('* <=> *', [
            query(':enter, :leave',
                style({
                    position: 'fixed',
                    width: '100%',
                    zIndex: 9999999
                }), { optional: true }),
            group([
                query(':enter ', [
                    style({
                        opacity: '0',
                        width: '100%',
                        overflow: 'hidden'
                    }),
                    animate('1ms 800ms', style({
                        opacity: '1',
                        overflow: 'visible'
                    }))
                ], { optional: true }),
                query(':leave', [
                    style({ opacity: '1' }),
                    animate('10ms 300ms cubic-bezier(0.770, 0.000, 0.175, 1.000)',
                        style({ opacity: '0' }))
                ], { optional: true }),
            ])
        ])
    ])
]
